import ArchiveIcon from '@material-ui/icons/Archive';
import EmailArchiveList from './EmailArchiveList';
import EmailArchiveShow from './EmailArchiveShow';

export default {
  list: EmailArchiveList,
  show: EmailArchiveShow,
  icon: ArchiveIcon
};
